import {Container, SmallView, Text1, Title1, View} from "../../../../styles/business-components";
import * as S from './styles'

import Image from '../../../../assets/images/business/b_m_cnt9_img1.png';

export const Content9 = () => {
    return (
        <S.CustomContainer>
            <View>
                <S.Content>
                    <S.ImageBlock>
                        <S.Image src={Image} alt={"image"}/>
                    </S.ImageBlock>
                    <div>
                        <S.Title>
                            Высокий уровень{'\n'}
                            шифрования{'\n'}
                            Анонимно{'\n'}
                            Надежно
                        </S.Title>
                    </div>
                    <S.Card>
                        <Text1>
                            <span>
                                Почему TeleGuard? Комплексная система сквозного шифрования делает невозможным доступ
                                к информации для третьих лиц. В каждой компании есть информация, которая должна оставаться внутренней.
                            </span>
                            <br/>
                            <br/>
                            <span>
                                TeleGuard предлагает самую надежную форму сквозного шифрования Salsa20/20. Это означает,
                                что ваши данные и коммуникации остаются внутри компании и гарантированно защищены от постороннего взгляда.
                            </span>
                        </Text1>
                    </S.Card>
                </S.Content>
            </View>
            <SmallView>
                <S.Title>
                    Высокий уровень шифрования{'\n'}
                    Анонимно{'\n'}
                    Надежно
                </S.Title>
                <S.SmallContent>
                    <S.ImageBlock>
                        <S.Image src={Image} alt={"image"}/>
                        <S.SmallCard>
                            <S.TextBlock>
                                <S.Text>
                                    Почему TeleGuard? Комплексная система сквозного шифрования делает невозможным доступ
                                    к информации для третьих лиц. В каждой компании есть информация, которая должна оставаться внутренней.
                                </S.Text>
                                <S.Text>
                                    TeleGuard предлагает самую надежную форму сквозного шифрования Salsa20/20. Это означает,
                                    что ваши данные и коммуникации остаются внутри компании и гарантированно защищены от постороннего взгляда.
                                </S.Text>
                            </S.TextBlock>
                        </S.SmallCard>
                    </S.ImageBlock>
                </S.SmallContent>
            </SmallView>
        </S.CustomContainer>
    )
}